import React from 'react';

import cx from 'classnames';

import { useLandingV2Context } from '../context';
import { ELandingDeviceType, ELandingHeaderLayout, ILandingHeaderConfig } from '../types';
import { getPrefix } from '../utils';
import s from './index.module.css';
import NavBar from './NavBar';
import TopBar from './TopBar';

interface ILandingV2HeaderProps {
  config: ILandingHeaderConfig;
}

const Header = ({ config }: ILandingV2HeaderProps) => {
  const { headerRef, deviceType } = useLandingV2Context();
  const hasMobileNav = config.navBar !== false && config.navBar.mobile && deviceType === ELandingDeviceType.Mobile;
  const hasDesktopNav = config.navBar !== false && config.navBar.desktop && deviceType === ELandingDeviceType.Desktop;

  return (
    <div
      className={cx(getPrefix('header'), s.header, config.layout === ELandingHeaderLayout.HalfWidth && s.halfWidth)}
      id="landingHeader"
      ref={headerRef}
    >
      {config.topBar !== false ? <TopBar /> : null}
      {hasMobileNav || hasDesktopNav ? <NavBar /> : null}
    </div>
  );
};

export default Header;
